export enum StorageKey {
  AccessToken = "accessToken",
  RefreshToken = "refreshToken",
  AccessTokenExpiresAt = "accessTokenExpiresAt",
  RefreshTokenExpiresAt = "refreshTokenExpiresAt",
  HasSeenTrialSubscriptionModal = "hasSeenTrialSubscriptionModal",
  IsPendingFaxNumberAfterProfile = "isPendingFaxNumberAfterProfile",
  IsPendingFaxNumberPurchase = "isPendingFaxNumberPurchase",
}
